/**
 * Return the global native browser window object
 */
function _window() {
    return window;
}
/**
 * Export a reference of the global native browser window object.
 */
var WindowRef = /** @class */ (function () {
    function WindowRef() {
    }
    Object.defineProperty(WindowRef.prototype, "nativeWindow", {
        get: function () {
            return _window();
        },
        enumerable: true,
        configurable: true
    });
    return WindowRef;
}());
export { WindowRef };
